import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../LayoutPage/Layout/Layout";
import { AuthContext } from "../../Logica/context/AuthContext";
import MateriasSelect from "../../ComboBox/MateriasSelect/MateriasSelect";
import LoginButton from "../../Button/LoginButton/LoginButton";
import LogoutButton from "../../Button/LogoutButton/LogoutButton";
import ConfirmarInscripcionButton from "../../Button/ConfirmarInscripcionButton/ConfirmarInscripcionButton";
import GenerarTokenButton from "../../Button/GenerarTokenButton/GenerarTokenButton";
import { auth } from "../../Logica/firebase/firebase";
import { signOut } from "firebase/auth";
import CustomModal from "../../Modal/CustomModal";
import DesinscribirMateriaModal from "../../Modal/DesinscribirMateriaModal";
import { MOSTRAR_ACOMODAMIENTO_SALONES } from "../../../utils/featureFlags";

const HomePage = () => {
  const { usuario, estadoUsuario, mensaje, userType, emailIntento } = useContext(AuthContext);
  const esAdmin = userType?.toLowerCase() === "admin";
  const [categoria, setCategoria] = useState("");
  const [materiaSeleccionada, setMateriaSeleccionada] = useState(null);
  const [user, setUser] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDesinscribirModal, setShowDesinscribirModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({
    title: "",
    message: "",
    tipo: "info",
    showLogout: false,
    mostrarDesinscribir: false,
  });

  useEffect(() => {
    if (estadoUsuario === "no-autorizado" || estadoUsuario === "error") {
      const desloguear = async () => {
        try {
          if (estadoUsuario === "no-autorizado") {
            if (mensaje === "Oferta LiFE agotada") {
              setModalInfo({
                title: "",
                message: "⚠️ Oferta LiFE agotada ⚠️",
                tipo: "info",
                showLogout: true,
              });
            } else if (mensaje?.includes("Ya cuentas con una actividad registrada.")) {
              setModalInfo({
                title: "",
                message: mensaje,
                tipo: "info",
                showLogout: true,
                mostrarDesinscribir: true,
              });
            } else {
              setModalInfo({
                title: "",
                message: mensaje,
                tipo: "error",
                showLogout: true,
                mostrarDesinscribir: false,
              });
            }
          } else if (estadoUsuario === "error") {
            setModalInfo({
              title: "Error de autenticación",
              message:
                "Ocurrió un error al validar tu usuario. Tu sesión se ha cerrado.",
              tipo: "error",
              showLogout: true,
              mostrarDesinscribir: false,
            });
          }

          setShowModal(true);
          await signOut(auth);
        } catch (error) {
          console.error("Error al desloguear automáticamente:", error);
        }
      };
      desloguear();
    }
  }, [estadoUsuario, mensaje]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();
  }, []);

  return (
    <Layout
      mostrarAside={!!materiaSeleccionada && estadoUsuario === "autorizado"}
      materiaSeleccionada={materiaSeleccionada}
    >
      {estadoUsuario === "cargando" && (
        <div className="text-center mt-5">Cargando...</div>
      )}

      {estadoUsuario === "no-autenticado" && (
        <div className="text-center mt-1">
          <LoginButton />
        </div>
      )}

      {estadoUsuario === "autorizado" && (
        <div className="container text-center mt-1">
          <div>
            <h2>🎉 Hola, {usuario.displayName || usuario.email}</h2>

            {esAdmin && (
              <div className="border rounded p-3 mb-3 bg-light">
                <h5 className="mb-3">Menú de administrador</h5>
                <div className="d-flex justify-content-center align-items-start gap-2 flex-wrap">
                  <GenerarTokenButton email={usuario.email} />
                  <Link to="/dashboard-admin" className="btn btn-outline-primary">
                    Ver dashboard
                  </Link>
                  {MOSTRAR_ACOMODAMIENTO_SALONES && (
                    <Link to="/acomodamiento-salones" className="btn btn-outline-primary">
                      Acomodamiento de salones
                    </Link>
                  )}
                  <Link to="/importar-datos" className="btn btn-outline-primary">
                    Importar datos
                  </Link>
                </div>
              </div>
            )}

            <p>Selecciona solo una actividad LiFE:</p>

            <div className="mt-4">
              <select
                className="form-select"
                value={categoria}
                onChange={(e) => {
                  setCategoria(e.target.value);
                  setMateriaSeleccionada(null);
                }}
              >
                <option value="">Selecciona una categoría</option>
                <option value="A">Talleres culturales</option>
                <option value="D">Clases deportivas</option>
              </select>

              {categoria && (
                <MateriasSelect
                  categoria={categoria}
                  onSeleccionarMateria={setMateriaSeleccionada}
                />
              )}

              {materiaSeleccionada && (
                <ConfirmarInscripcionButton
                  email={usuario.email}
                  materia={materiaSeleccionada}
                  onConfirmado={() => {
                    setMateriaSeleccionada(null);
                    setCategoria("");
                  }}
                />
              )}
            </div>
          </div>
          <div className="container text-center mt-1">
            {user ? <LogoutButton /> : null}
          </div>
        </div>
      )}

      {estadoUsuario === "no-autorizado" && (
        <div className="text-center mt-5">{mensaje}</div>
      )}

      {estadoUsuario === "error" && (
        <div className="text-center mt-5">
          ⚠️ Error al validar tu usuario. Intenta más tarde.
        </div>
      )}

      {/* MODAL DE ERROR */}
      <CustomModal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={modalInfo.title}
        message={modalInfo.message}
        tipo={modalInfo.tipo}
        showLogout={modalInfo.showLogout}
        mostrarDesinscribir={modalInfo.mostrarDesinscribir}
        onDesinscribir={() => {
          setShowModal(false);
          setShowDesinscribirModal(true);
        }}
      />

      <DesinscribirMateriaModal
        show={showDesinscribirModal}
        email={emailIntento}
        onClose={() => setShowDesinscribirModal(false)}
      />
    </Layout>
  );
};

export default HomePage;
